import React from 'react';
import PropTypes from 'prop-types';

import { Button, Col, Row } from 'react-bootstrap';
import { css, StyleSheet } from 'aphrodite';

import { areYouSure } from 'lib/utils/toast';
import { brandCleanupUserActions, suggestedActionsOptions } from 'lib/enums/BrandCleanupEnums';
import Container from 'components/shared/Container';
import {
  lightSalmon,
  positiveGreen,
  positiveGreenBackground,
  salmon,
  shadowSoftBlue,
  warmBlue,
} from 'lib/css/colors';

function BrandCleanupActionsSection({
  selectedProductIds,
  cleanupBrandsOfSelectedProducts,
  setShowBrandCleanupModal,
  products,
  showAssignBrandsSection,
  setShowAssignBrandsSection,
  hasCleanupBrandsPermission,
}) {
  return (
    <Container>
      <Row className="d-flex align-items-center">
        <Col className="d-flex justify-content-start">
          {hasCleanupBrandsPermission ? (
            <Button
              className={css(styles.approveTraineeSuggestedActionButton)}
              variant="outline-primary"
              onClick={() => {
                areYouSure(
                  () =>
                    cleanupBrandsOfSelectedProducts({
                      selected_brand_cleanup_record_ids: selectedProductIds,
                      user_suggested_action:
                        brandCleanupUserActions.APPROVE_TRAINEE_SUGGESTED_ACTION,
                    }),
                  'Are you sure you want to Approve the Trainee Suggested Action?',
                );
              }}
              disabled={!selectedProductIds.length}
            >
              Approve Trainee Suggested action.
            </Button>
          ) : null}
          <Button
            className="ml-2"
            variant="primary"
            onClick={() => {
              setShowAssignBrandsSection(!showAssignBrandsSection);
            }}
            disabled={!selectedProductIds.length}
          >
            Assign brand and manufacturer for Selected Products
          </Button>
          <Button
            className={css(styles.detachButton)}
            variant="outline-primary"
            onClick={() => {
              areYouSure(
                () =>
                  cleanupBrandsOfSelectedProducts({
                    selected_brand_cleanup_record_ids: selectedProductIds,
                    user_suggested_action: brandCleanupUserActions.DETACH_CURRENT_BRAND,
                  }),
                'Are you sure you want to Detach the brands of the selected Products?',
              );
            }}
            disabled={!selectedProductIds.length}
          >
            Detach Current Brands of Selected Products
          </Button>
          <Button
            className={css(styles.keepButton)}
            variant="outline-primary"
            onClick={() => {
              areYouSure(
                () =>
                  cleanupBrandsOfSelectedProducts({
                    selected_brand_cleanup_record_ids: selectedProductIds,
                    user_suggested_action: brandCleanupUserActions.KEEP_CURRENT_BRAND,
                  }),
                'Are you sure you want to Keep the brands of the selected Products?',
              );
            }}
            disabled={!selectedProductIds.length}
          >
            Keep Current Brands of Selected Products
          </Button>
          <Button
            className={css(styles.keepButton)}
            variant="outline-primary"
            onClick={() => {
              areYouSure(
                () =>
                  cleanupBrandsOfSelectedProducts({
                    selected_brand_cleanup_record_ids: selectedProductIds,
                    user_suggested_action: brandCleanupUserActions.ASSIGN_SUGGESTED_BRAND,
                  }),
                'Are you sure you want to Assign the suggested brands for the selected Products?',
              );
            }}
            disabled={!selectedProductIds.length}
          >
            Assign Suggested Brands for Selected Products
          </Button>
          <Button
            className="ml-2"
            variant="primary"
            onClick={() => setShowBrandCleanupModal(true)}
            disabled={!selectedProductIds.length || selectedProductIds.length !== 1}
          >
            View{' '}
            {
              suggestedActionsOptions.find(action => action.value === products[0]?.suggested_action)
                ?.label
            }
            Reasonings for selected product
          </Button>
        </Col>
      </Row>
      <Row className="d-flex align-items-center mt-2">
        <Col className="d-flex justify-content-start">
          <Button
            className={css(styles.keepButton)}
            variant="outline-primary"
            onClick={() => {
              areYouSure(
                () =>
                  cleanupBrandsOfSelectedProducts({
                    selected_brand_cleanup_record_ids: selectedProductIds,
                    user_suggested_action: brandCleanupUserActions.NEED_DP_ASSISTANCE,
                  }),
                'Are you sure selected products require DP assistance?',
              );
            }}
            disabled={!selectedProductIds.length}
          >
            Need DP Assistance
          </Button>
          <Button
            className={css(styles.keepButton)}
            variant="outline-primary"
            onClick={() => {
              areYouSure(
                () =>
                  cleanupBrandsOfSelectedProducts({
                    selected_brand_cleanup_record_ids: selectedProductIds,
                    user_suggested_action: brandCleanupUserActions.MARK_AS_NON_BRANDED,
                  }),
                'Are you sure you want to Mark as Non-Branded for the selected Products?',
              );
            }}
            disabled={!selectedProductIds.length}
          >
            Mark as Non-Branded
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

const styles = StyleSheet.create({
  keepButton: {
    maxHeight: '50px',
    marginLeft: '4px',
    borderColor: positiveGreen,
    color: positiveGreen,
    ':hover': {
      backgroundColor: positiveGreenBackground,
      borderColor: positiveGreenBackground,
    },
  },
  detachButton: {
    maxHeight: '50px',
    marginLeft: '4px',
    marginRight: '4px',
    borderColor: salmon,
    color: salmon,
    ':hover': {
      backgroundColor: lightSalmon,
      borderColor: lightSalmon,
    },
  },
  approveTraineeSuggestedActionButton: {
    maxHeight: '50px',
    marginLeft: '4px',
    marginRight: '4px',
    borderColor: warmBlue,
    color: warmBlue,
    ':hover': {
      backgroundColor: shadowSoftBlue,
      borderColor: shadowSoftBlue,
    },
  },
});

BrandCleanupActionsSection.propTypes = {
  selectedProductIds: PropTypes.array.isRequired,
  cleanupBrandsOfSelectedProducts: PropTypes.func.isRequired,
  setShowBrandCleanupModal: PropTypes.func.isRequired,
  products: PropTypes.array.isRequired,
  selectedSuggestedAction: PropTypes.object.isRequired,
  selectedSuggestedBrand: PropTypes.object.isRequired,
  showAssignBrandsSection: PropTypes.bool.isRequired,
  setShowAssignBrandsSection: PropTypes.func.isRequired,
  hasCleanupBrandsPermission: PropTypes.bool.isRequired,
};

export default BrandCleanupActionsSection;
